<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group">
        <FloatingLabel
          type="text"
          input-class="form-control form-control-xl border-color-3"
          label="Nome Completo (sem abreviação)"
          v-model="fullName"
          v-on:blur="checkFullName"
        />
        <small class="form-text text-danger" v-if="fullNameMessage">{{
          fullNameMessage
        }}</small>
      </div>

      <div class="form-group">
        <FloatingLabel
          type="email"
          input-class="form-control form-control-xl border-color-3"
          label="E-mail"
          v-model="email"
          v-on:blur="checkEmail.length > 0 && checkEmailConfirm()"
        />
        <small class="form-text text-danger" v-if="emailMessage">{{
          emailMessage
        }}</small>
      </div>

      <div class="form-group">
        <FloatingLabel
          type="email"
          input-class="form-control form-control-xl border-color-3"
          label="Repita seu e-mail"
          v-model="emailConfirm"
          v-on:blur="checkEmailConfirm"
        />
        <small class="form-text text-danger" v-if="emailConfirmMessage">{{
          emailConfirmMessage
        }}</small>
      </div>

      <!-- <div class="form-group" v-show="!$store.state.deviseTrying.hasOwnProperty('isForeign')">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="foreign" v-model="isForeign">
          <label class="custom-control-label" for="foreign">Sou estrangeiro</label>
        </div>
      </div> -->

      <div
        class="form-group"
        v-show="!$store.state.deviseTrying.hasOwnProperty('document')"
      >
        <input
          v-if="!isForeign"
          type="text"
          class="form-control form-control-xl border-color-3"
          placeholder="CPF"
          required
          v-model="document"
          @blur="checkDocument"
          v-mask="'###.###.###-##'"
        />
        <input
          v-if="isForeign"
          type="text"
          class="form-control form-control-xl border-color-3"
          placeholder="RNE"
          required
          v-model="document"
          @blur="checkDocument"
          v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
        />

        <small class="form-text text-danger" v-if="documentMessage">{{
          documentMessage
        }}</small>
      </div>

      <div class="form-group form-row">
        <div class="col-6">
          <FloatingLabel
            type="password"
            input-class="form-control form-control-xl border-color-3"
            label="Senha"
            v-b-tooltip.focus="'Sua senha deve ter no mínimo 8 caracteres'"
            v-model="password"
            v-on:blur="passwordConfirm.length > 0 && checkPasswordConfirm()"
          />
        </div>

        <div class="col-6">
          <FloatingLabel
            type="password"
            input-class="form-control form-control-xl border-color-3"
            label="Repita sua senha"
            v-model="passwordConfirm"
            v-on:blur="checkPasswordConfirm"
          />
          <small class="form-text text-danger" v-if="passwordConfirmMessage">{{
            passwordConfirmMessage
          }}</small>
        </div>
      </div>

      <vue-recaptcha
        class="d-flex justify-content-center"
        :loadRecaptchaScript="true"
        sitekey="6LexzmQUAAAAACSwQGT6QOH_1yrY7xYdkvnG9Dvj"
        @verify="recaptchaVerify"
        @expired="recaptchaExpired"
      ></vue-recaptcha>

      <div
        class="
          custom-control
          custom-checkbox
          custom-checkbox-lg
          custom-checkbox-background
          my-3
        "
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="accept-terms"
          v-model="acceptTerms"
        />
        <label class="custom-control-label" for="accept-terms"
          >Estou ciente do
          <a href="" @click.prevent="sendToTerms()"
            >Aviso de Tratamento de Dados Pessoais de Candidatos</a
          ></label
        >
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-center
          text-center
          mt-3
        "
      >
        <a
          href="#"
          class="text-color-3 font-weight-bold mr-3"
          @click.prevent="$emit('changeModal', 'login')"
          >Voltar para Login</a
        >
        <button
          type="submit"
          class="btn btn-color-1 text-white px-4 px-4"
          :disabled="!canSubmit"
        >
          Criar Usuário
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "RegisterForm",

  data() {
    return {
      firstName: this.$store.state.deviseClosedToReadTerms.first_name || "",
      lastName: this.$store.state.deviseClosedToReadTerms.last_name || "",
      fullName: this.$store.state.deviseClosedToReadTerms.full_name || "",
      email: this.$store.state.deviseClosedToReadTerms.email || "",
      emailConfirm: "",
      isForeign: this.$store.state.deviseTrying.isForeign || false,
      document: this.$store.state.deviseTrying.document || "",
      password: "",
      passwordConfirm: "",
      recaptchaChecked: false,
      nameMessage: null,
      fullNameMessage: null,
      emailMessage: null,
      documentMessage: null,
      emailConfirmMessage: null,
      passwordConfirmMessage: null,
      acceptTerms: false,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.fullName.length > 2 &&
        this.$helpers.isEmail(this.email) &&
        ((this.isForeign && this.document.length > 5) ||
          (!this.isForeign && this.$helpers.isCPF(this.document))) &&
        this.$helpers.validPassword(this.password) &&
        this.email == this.emailConfirm &&
        this.password == this.passwordConfirm &&
        this.recaptchaChecked &&
        this.acceptTerms
      );
    },
  },

  components: {
    VueRecaptcha,
    FloatingLabel,
  },

  watch: {
    // Limpa documento quando muda a flag de estrangeiro
    isForeign: function (newValue, oldValue) {
      this.document = "";
      this.documentMessage = null;
    },
  },

  mounted() {
    if (this.$store.state.deviseClosedToReadTerms.first_name) {
      this.$store.commit("DEVISE_DEVISE_CLOSED_TO_READ_TERMS", null);
    }
  },

  methods: {
    checkFullName() {
      var partsOfName = this.fullName.split(" ");
      this.firstName = partsOfName.splice(0, 1).join().trim();
      this.lastName = partsOfName.join(" ").trim();

      if (!this.fullName) {
       return this.fullNameMessage = "Nome inválido";
      } else if (this.firstName.length > 2 && this.lastName.length > 3) {
        return (this.fullNameMessage = null);
      } else {
        return (this.fullNameMessage = "Nome muito curto");
      }
    },

    checkEmail() {
      this.emailMessage = this.$helpers.isEmail(this.email)
        ? null
        : "E-mail inválido";
    },

    checkEmailConfirm() {
      this.emailConfirmMessage =
        this.email == this.emailConfirm ? null : "E-mails diferentes";
    },

    checkDocument() {
      if (!this.isForeign) {
        this.documentMessage = this.$helpers.isCPF(this.document)
          ? null
          : "CPF inválido";
      } else {
        this.documentMessage = this.document.length > 5 ? null : "RNE inválido";
      }
    },

    checkPasswordConfirm() {
      this.passwordConfirmMessage =
        this.password == this.passwordConfirm ? null : "Senhas diferentes";
    },

    recaptchaVerify() {
      this.recaptchaChecked = true;
    },

    recaptchaExpired() {
      this.recaptchaChecked = false;
    },

    sendToTerms() {
      let current_profile = this.$store.state.deviseTrying;
      current_profile.first_name = this.firstName;
      current_profile.last_name = this.lastName;
      current_profile.email = this.email;
      current_profile.isForeign = this.isForeign;
      current_profile.document = this.document;
      current_profile.password = this.password;
      current_profile.provider = null;
      current_profile.id = null;
      current_profile.accept_terms_of_use = this.acceptTerms;
      this.$store.commit("DEVISE_DEVISE_CLOSED_TO_READ_TERMS", current_profile);
      this.$router.push("/termos-de-uso");
    },

    submit() {
      let current_profile = this.$store.state.deviseTrying;
      current_profile.first_name = this.firstName;
      current_profile.last_name = this.lastName;
      current_profile.email = this.email;
      current_profile.isForeign = this.isForeign;
      current_profile.document = this.document;
      current_profile.password = this.password;
      current_profile.provider = null;
      current_profile.id = null;
      current_profile.accept_terms_of_use = this.acceptTerms;
      this.$store.commit("DEVISE_TRYING", current_profile);
      this.$store.commit("DEVISE_DEVISE_CLOSED_TO_READ_TERMS", null);

      window.signUp = true;

      this.$emit("signUp");
    },
  },
};
</script>

<style lang="scss"></style>